"use client"
import React from 'react'
import { useLanguage } from '../../providers/LanguageProvider'
import { motion } from "framer-motion";

const GetQuoteFooter = () => {
    const { language } = useLanguage()
  const isArabic = language === 'ar'
  return (
    <div className="w-full pt-[80px] pb-[100px] lg:pb-[200px] ">
      <div className="section-container flex flex-col md:items-center mx-auto">
        {isArabic ? (
  <>
    <motion.h2
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      viewport={{ once: true }}
      className="text-[24px] sm:text-[28px] md:text-[32px] xl:text-[42px] font-medium text-[#414141] mb-8 leading-snug"
    >
      نیحل شیل كرحتت ؟
    </motion.h2>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2, ease: "easeOut" }}
      viewport={{ once: true }}
      className="text-gray-500 text-[14px] sm:text-[15px] md:text-[16px] xl:text-[15px] 2xl:text-lg leading-5 font-light"
    >
      رفوتلا دودحم يف مسوم ةورذلا، زجحلا ركبملا نمضی كل ةحاسملا تامدخلاو معدلاو، ریدم باسح
      صصخم لصاوتی كعم للاخ موی لمع دحاو، ّل يتسجول يلخاد صخرم طبترمو ءانیملاب، لماعتت عم
      مشغ.
    </motion.p>
  </>
) : (
  <>
    <motion.h2
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      viewport={{ once: true }}
      className="text-[24px] sm:text-[28px] md:text-[32px] xl:text-[42px] font-medium text-[#414141] mb-8 leading-snug capitalize"
    >
      Why Act now ?
    </motion.h2>

    <motion.p
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: 0.2, ease: "easeOut" }}
      viewport={{ once: true }}
      className="text-gray-500 md:text-center text-[15px] sm:text-[15px] md:text-[15px] xl:text-[15px] !leading-[1.3rem] xl:w-[985px]"
    >
      Availability is limited in peak season. Booking early ensures you secure space,
      services, and support. Dedicated account manager follows up within 1 business
      day. You’re working with a fully licensed, port-connected inland logistics operator
    </motion.p>
  </>
)}
      </div>
    </div>
  )
}

export default GetQuoteFooter
